module.exports = __webpack_public_path__ + "img/uid_x2.a43d4161.png";